module.exports = __webpack_public_path__ + "static/media/Japan.de18efe0.jpg";